module.exports = __webpack_public_path__ + "img/30_16.9881ff9f.png";